import $ from 'jquery';
// import buttonsGetLine from '../Button/buttonsGetLine';

export default (container = document) => {
  $('[data-rte-lookbook-slider]', container).each((i, gallery) => {
    const $gallery = $(gallery);
    let num_slides = 0;
    const gallery_id = `LookbookGallery--${i + 1}`;

    if (!$gallery.attr('id')) {
      $gallery.attr('id', gallery_id);
    }

    $gallery.addClass('LookbookGallery').addClass('Gallery').addClass('AnimateOnLoad').addClass('Animate--slide-up');
    $gallery.find('img').each((index, img) => {
      num_slides += 1;
      const $img = $(img);
      const img_src = $img.attr('src');

      $img.replaceWith(`<div class="Gallery__slide Gallery__slide--peaks" data-slide style="background-image: url('${img_src}');">
        ${$img.data('link') ? `<a class="Gallery__slide-link" href="${$img.data('link')}"></a>` : ''}
        ${$img.data('cta') 
          ? `<div class="Gallery__desktop">
              <a class="Gallery__slide-cta Button Button--primary" href="${$img.data('link') || '#'}">${$img.data('cta')}</a>
            </div>
            <div class="Gallery__mobile">
              <a class="Gallery__slide-cta Button Button--narrow Button--primary" href="${$img.data('link') || '#'}">${$img.data('cta')}</a>
            </div>` 
          : ''}
      </div>`);
    });

    if (num_slides < 10) {
      num_slides = `0${num_slides}`;
    }

    $gallery.append(`<div class="Gallery__position Gallery__position--with-peak"><span data-current-position>01</span> / ${num_slides}</div>`);
    // buttonsGetLine();
  });
};